window.GC = window.GC || {};
GC.queue = GC.queue || [];

GC.enqueue = GC.enqueue || function (func) {
  GC.queue.push({
    method: func
  });
};

(function (GC) {
  var getUrlParameter = function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  var GCBase = function GCBase() {
    var isDebug = function isDebug() {
      var debugLevel = getUrlParameter('gcdebug');

      if (debugLevel) {
        return debugLevel;
      }
    };

    var debug = isDebug();
    var base = {
      debug: debug,
      log: function log(msg, lvl) {
        if (base.debug) {
          lvl = lvl || 'log';

          try {
            console[lvl]('::GC:: ' + msg);
          } catch (e) {
            console.log('::GC::[' + lvl + ']: ' + msg);
          }
        }
      },
      tasks: {
        processed: [],
        errors: []
      },
      processQueue: function processQueue(queue) {
        if (Array.isArray(queue)) {
          this.queue = queue.map(this._process).filter(function (task) {
            return task;
          });
        }
      },
      _process: function _process(task) {
        var args = task.args;
        var method = task.method;
        task.timestamp = Date.now();

        try {
          method.apply(base, args);
          base.tasks.processed.push(task);
        } catch (e) {
          base.tasks.errors.push({
            error: e,
            task: task
          });
          base.log('Error proccessing task: ' + e + ' -- ' + task.method + ' ' + task.args, 'error');
        }
      },
      _loadModule: function _loadModule(mount, module) {
        // Check for an existing library
        var existing = base[mount] || {}; // Merge the new module into the existing library, if it is present.
        // NOTE: This merge is shallow, any differnces between `existing` and `module`
        // more than one level deep will not register.

        base[mount] = Object.assign({}, existing, module);
      }
    };
    return base;
  };

  var GCHelpers = function GCHelpers() {
    return {
      getUrlParameter: getUrlParameter,
      removeItem: function removeItem(arr, item) {
        return arr.filter(function (arrItem) {
          return arrItem != item;
        });
      },
      loadScript: function loadScript(src, cb) {
        var script = document.createElement('script');

        cb = cb || function () {};

        script.async = true;
        script.src = src;

        script.onerror = function () {
          cb(new Error('Failed to load' + src));
        };

        script.onload = function () {
          cb();
        };

        document.getElementsByTagName('head')[0].appendChild(script);
      },
      onReady: function onReady(cb, readyState) {
        readyState = readyState || 'complete';

        var alreadyLoaded = function alreadyLoaded() {
          return document.readyState === 'complete';
        };

        if (!alreadyLoaded()) {
          var onReady = function onReady(event) {
            if (event.target.readyState === readyState || alreadyLoaded()) {
              cb();
            }
          };

          document.addEventListener('readystatechange', onReady);
        } else {
          cb();
        }
      }
    };
  };

  GC = new GCBase();

  GC._loadModule('helpers', new GCHelpers());

  var processErrors = function processErrors() {
    var errors = GC.tasks.errors;

    if (errors.length) {
      errors.forEach(function (error) {
        GC.log('retrying on error: ' + error.error, 'debug');
        GC.queue.push(error.task);
      });
    }
  };

  GC.helpers.onReady(function () {
    if (GC.queue.ready) return;
    GC.processQueue(window.GC.queue); // After processing the queue, stub out the `push` method to
    // directly call the `_process` method. This way we don't have to worry
    // about having actions sent to the queue after the document is complete.

    GC.queue = {
      ready: true,
      push: GC._process
    };
  }, 'interactive');
  GC.helpers.onReady(processErrors, 'complete');

  if (window.GC) {
    Object.keys(window.GC).forEach(function (key) {
      if (GC[key]) {
        GC.log('Duplicate GC declaration. Overwriting ' + key, 'error');
      }

      GC[key] = window.GC[key];
    });
  }

  window.GC = GC;
})(window.GC || {});